module.exports = __webpack_public_path__ + "img/critical-inquiry-cover.8256797a.jpg";